import React from 'react';
import { MusicContent as Content } from '../ContentModules/MusicContent';
import { Comp10 } from '../Components/Comp10';

const MusicPage = (props) => {

    return (
        <div id='musicpage' className="page-content">
            
            <Comp10 title={"Music"} />

            <div id="generic-section-1" className="content-container shadow-behind container-first">
                <h3 className="underline text-x-large">Section Title</h3>
                {
                    props.mobile
                        ? <div>
                            <p>First Container Content</p>
                            <p>Is Mobile</p>
                        </div>
                        : <div>
                            <p>First Container Content</p>
                            <p>Isn't Mobile</p>
                        </div>
                }
            </div>
            <div id="generic-section-2" className="content-container shadow-behind">
                <h3 className="underline text-x-large">Section Title</h3>
                {
                    props.mobile
                        ? <div>
                            <p>Middle Container Content</p>
                            <p>Is Mobile</p>
                        </div>
                        : <div>
                            <p>Middle Container Content</p>
                            <p>Isn't Mobile</p>
                        </div>
                }
            </div>
            <div id="generic-section-3" className="content-container shadow-behind container-last">
                <h3 className="underline text-x-large">Section Title</h3>
                {props.mobile
                    ? <div>
                        <p>Last Container Content</p>
                        <p>Is Mobile</p>
                    </div>
                    : <div>
                        <p>Last Container Content</p>
                        <p>Isn't Mobile</p>
                    </div>
                }
            </div>
        </div>
    )
}

export { MusicPage }